import LottieView from 'lottie-react-native';
import { View } from 'smoothie';

import Hello from '../../../../assets/animations/fruitful-hello.json';

const WelcomeAnimation = () => {
    return (
        <View width={40} height={40}>
            <LottieView
                source={Hello}
                autoPlay={true}
                loop={false}
                resizeMode="cover"
                style={{
                    width: '100%',
                    height: '100%',
                }}
            />
        </View>
    );
};

export default WelcomeAnimation;
